var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alerts"},[_c('transition-group',{attrs:{"name":"alert"}},_vm._l((_vm.alerts),function(alert){return _c('v-alert-container',{key:alert.key,attrs:{"alert":alert}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }